module.exports = __webpack_public_path__ + "static/media/wifi-icon.6314020d.png";